// extracted by mini-css-extract-plugin
module.exports = {"live-section-title":"style_live-section-title__f_njM"};